import React, {Fragment} from 'react';
import {Link} from "react-router-dom";
import ThemeLabelContainer from "../theme-card/ThemeLabelContainer";
import remToPixels from "../../utils/remToPixels";
import ModalFullscreenActions from "../../flux/ModalFullscreenActions";
import Dispatcher from "../../flux/Dispatcher";
import ActionTypes from "../../flux/ActionTypes";
import RenderOnMobile from "../responsive/RenderOnMobile";
import RenderOnTablet from "../responsive/RenderOnTablet";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import styled, { withTheme } from "styled-components";

function SearchResult({
  linkTo,
  cover,
  breadcrumb,
  title,
  translatedTitle,
  confidential,
  furSpecialist = false,
  childrenContainerStyle,
  children,
  ...props
}) {
  const handleClick = () => {
    ModalFullscreenActions.close();
    Dispatcher.dispatch({
      actionType: ActionTypes.ROUTER_NAVIGATE,
      url: linkTo
    });
  };

  const resultItemProps = {
    confidential,
    furSpecialist,
    cover,
    title,
    translatedTitle,
    breadcrumb,
    childrenContainerStyle,
    ...props,
  };

  return (
    <Fragment>
      <RenderOnMobile>
        <a onClick={handleClick} style={{ display: 'block', color: 'inherit' }}>
          <SearchResultItem {...resultItemProps} />
        </a>
      </RenderOnMobile>

      <RenderOnTablet>
        <Link to={linkTo} style={{ color: 'inherit' }}>
          <SearchResultItem {...resultItemProps} />
        </Link>
      </RenderOnTablet>
    </Fragment>
  );
}

export default withTheme(SearchResult);

function SearchResultItem({
  confidential,
  furSpecialist,
  cover,
  title,
  translatedTitle,
  breadcrumb,
  childrenContainerStyle,
  children,
  ...props
}) {

  return (
    <div {...props} style={{
      position: 'relative',
      display: 'flex',
      alignItems: 'flex-start',
      margin: '1.5rem 0',
      boxShadow: '-3px 3px 8px 1px rgba(0, 0, 0, 0.1)',
    }}>

      <ThemeLabelContainer theme={{confidential, furSpecialist}} />

      {cover !== null && (
        <div style={{
          alignSelf: 'center',
          flexShrink: 0,
          width: themeResponsiveProperty('40%', '25%')(props),
        }}>
          <div style={{
            // Will yield the desired image ratio.
            paddingBottom: '78.57142857%',
            backgroundImage: `url(${cover.replace('0x0', `${remToPixels(15.625)}x0`)})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}/>
        </div>
      )}

      <LabelContainer>
        <h3 style={{
          marginTop: 0,
          marginBottom: '.5rem',
          color: '#000',
          textTransform: 'uppercase',
          fontWeight: 'bold',
        }}>
          {title}
          {translatedTitle && (
            <span style={{ fontWeight: 'normal' }}> / {translatedTitle}</span>
          )}
        </h3>
        <small style={{
          display: 'block',
          marginBottom: '.5rem',
        }}>
          {breadcrumb.join(' / ')}
        </small>
        <div dir="auto" style={childrenContainerStyle}>{children}</div>
      </LabelContainer>
    </div>
  );
}

const LabelContainer = styled.div`
  padding: ${themeResponsiveProperty('.75rem', '2rem')};
  flex-grow: 1;
`;
